module.exports = __webpack_public_path__ + "static/media/9DESA21.ca13c9e7.jpg";